import { defineComponent as r, h as e } from "vue";
const d = r({
  name: "DropdownDivider",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  render() {
    return e("div", {
      class: `${this.clsPrefix}-dropdown-divider`
    });
  }
});
export {
  d as default
};
